export default {
    subscribe: {
        name: {
            label: 'Nombre',
            placeholder: 'Nombre',
        },
        lastName: {
            label: 'Apellidos',
            placeholder: 'Apellidos',
        },
        phone: {
            label: 'Teléfono',
            placeholder: 'Teléfono',
        },
        email: {
            label: 'Email',
            placeholder: 'Email',
        },
        privacy: {
            label: 'He leído y acepto <1>la política de privacidad</1> <2>[+]</2>',
            text: "Le informamos de que Andbank España, S.A., con domicilio social en Paseo Castellana 55, 3º, recaba sus datos personales para su tratamiento, que se fundamenta en el interés del usuario en establecer contacto con Andbank como también en el interés legítimo de Andbank en poder atender las consultas que puedan formular los potenciales clientes y al objeto de remitirle comunicaciones comerciales sobre nuestros productos. El interesado podrá, revocar en cualquier momento la autorización concedida para el tratamiento de los datos personales, así como ejercitar los derechos de acceso, rectificación, oposición, limitación, supresión, portabilidad y a no ser objeto de decisiones automatizadas dirigiéndose por escrito a Paseo de la Castellana, 55, 3 Planta, 28046, Madrid, o a <1>dpo@andbank.es</1>"
        },
        newsletter: {
            label:
                'Acepto recibir de Andbank/MyInvestor u otras entidades del Grupo Andbank, inclusive por vía telemática, información sobre educación financiera.',
        },
        submit: 'Enviar',
    },

    crossword: {
        name: {
            label: 'Nombre',
            placeholder: 'Nombre',
        },
        lastName: {
            label: 'Apellidos',
            placeholder: 'Apellidos',
        },
        phone: {
            label: 'Teléfono',
            placeholder: 'Teléfono',
        },
        email: {
            label: 'Email',
            placeholder: 'Email',
        },
        privacy: {
            label: 'He leído y acepto <1>la política de privacidad</1> <2>[+]</2>',
            text: "Le informamos de que Andbank España, S.A., con domicilio social en Paseo Castellana 55, 3º, recaba sus datos personales para su tratamiento, que se fundamenta en el interés del usuario en establecer contacto con Andbank como también en el interés legítimo de Andbank en poder atender las consultas que puedan formular los potenciales clientes y al objeto de remitirle comunicaciones comerciales sobre nuestros productos. El interesado podrá, revocar en cualquier momento la autorización concedida para el tratamiento de los datos personales, así como ejercitar los derechos de acceso, rectificación, oposición, limitación, supresión, portabilidad y a no ser objeto de decisiones automatizadas dirigiéndose por escrito a Paseo de la Castellana, 55, 3 Planta, 28046, Madrid, o a <1>dpo@andbank.es</1>"
        },
        newsletter: {
            label:
                'Acepto suscribirme (o estoy ya suscrito) al blog de MyInvestor. <1>Bases del sorteo</1>',
        },
        submit: 'Enviar',
    },
};
